import reference from '@/api/modules/reference';
import lot from '@/api/modules/lot';

export default {
	setReference(context, typeRef) {
		context.commit('setReferenceType', typeRef);
	},

	async getReferenceList(context, { typeRef, params = '' }) {
		try {
			if (typeRef.type === 'warehouses') {
				// Костыль для скрытия поставщиков из складов (бэк не может сделать запрос, если что, это к Витале)
				const paramWarehouses  = `${typeRef.type}${params}`;
				let resultWarehouses = await reference.getReferenceList(paramWarehouses);
				const paramContractors = 'contractors?type=PROVIDER';
				const resultContractors = await reference.getReferenceList(paramContractors);
        
				resultWarehouses = resultWarehouses.filter(warehouse => {
					const finded = resultContractors.find(contractor => contractor.id === warehouse.contractor_id && contractor.type === 'PROVIDER');
					return finded ? false : true;
				});

				context.commit('setReference', resultWarehouses);
				context.commit('setReferenceType', typeRef);
				// Костыль закончен
			} else { 
				const param = `${typeRef.type}${params}`;
				const result = await reference.getReferenceList(param);

				context.commit('setReference', result);
				context.commit('setReferenceType', typeRef);
			}      
		} catch (err) {
			//
		}
	},

	// этот метод нужен для получения списка других сущностей, которые используются при создании текущей сущности
	async getReferenceSubList(context, { type }) {
		try {
			return await reference.getReferenceList(type);
		} catch (err) {
			//
		}
	},

	async createReference(context, { type, ref, params ='' }) {
		try {
			const result = await reference.createReference({ type, ref });
			context.dispatch('getReferenceList', { typeRef: context.state.referenceType, params });
			return result;
		} catch (err) {
			//
		}
	},

	async editReference(context, { type, ref, params = '' }) {
		try {
			await reference.editReference({ type, ref });
			context.dispatch('getReferenceList', { typeRef: context.state.referenceType, params });
		} catch (err) {
			// 
		}
	},

	async deleteReference(context, { id, params = '', item = {} }) {
		try {
			let currentType = context.state.referenceType.type;
			if (['warehouses', 'contacts'].includes(params)) {
				currentType = params;
			}

			// Костыль для удаления задублированных складов от поставщика
			if (currentType === 'contractors' && item.contacts.length) {
				const warehousesArr = await lot.getWarehouses();

				for (const warehouse of warehousesArr) {
					if (warehouse.contractor_id === item.id && item.type === 'PROVIDER') {
						await reference.deleteReference({ type: 'warehouses', id: warehouse.id });
					}
				}
			}
			// Конец костыля

			await reference.deleteReference({ type: currentType, id });
			context.dispatch('getReferenceList', { typeRef: context.state.referenceType, params });
		} catch (err) {
			//
		}
	}
};
